import { ApiResult, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

import { StaticSitesDetailApi } from '../static-sites-detail/api/static-sites-detail-api';
import { StaticSitesListApi } from '../static-sites-list/api/static-sites-list-api';

export class StaticSitesApi {
    constructor(protected baseUrl: string) {
        this.StaticSitesList = new StaticSitesListApi(this.baseUrl);
        this.StaticSitesDetail = new StaticSitesDetailApi(this.baseUrl);
    }

    public StaticSitesList: StaticSitesListApi;
    public StaticSitesDetail: StaticSitesDetailApi;

    public deleteStaticSites(id: number): Promise<ApiResult<void>> {
        return safeRequest(() => request.delete(`${this.baseUrl}/static-sites/${id}`), noop);
    }
}
